import React from 'react'

import { Suggestion } from '@components/common/Suggestion'
import { useCurrentShopQuery } from '@modules/Dashboard/hooks/useCurrentShopQuery'
import { useCreatorIntegrationsQuery } from '@modules/Dashboard/pages/Apps'
import { useSocialLinksQuery } from '@modules/ThemeEditorV2/modules/SocialLinks'
import { routing } from '@utils/routing'

import type { Recommendation } from '../../../Recommendations.types'
import { useRecommendationsDismiss } from '../../../hooks/useRecommendationsDismiss'
import setUpTwitchGifting from '../assets/set-up-twitch-gifting.png'

export const useTwitchGiftingRecommendation = () => {
  const { recommendationsDismiss, createOnDismiss } = useRecommendationsDismiss()
  const { currentShopQuery } = useCurrentShopQuery()
  const { socialLinksQuery } = useSocialLinksQuery([currentShopQuery.data?.id!], {
    enabled: currentShopQuery.isSuccess && !!currentShopQuery.data.id,
    staleTime: 60_000,
  })
  const { creatorIntegrationsQuery } = useCreatorIntegrationsQuery(undefined, { staleTime: 60_000 })

  return {
    twitchGiftingRecommendation: {
      // "LOGIC: only visible to Twitch creators; disappears after Twitch App is enabled (Twitch creator = if in social there is Twitch set up assume this is Twitch creator)",
      id: 'twitchGifting',

      enabled:
        socialLinksQuery.isSuccess &&
        socialLinksQuery.data.socialNetworks.some(({ name }) => name === 'twitch') &&
        creatorIntegrationsQuery.isSuccess &&
        creatorIntegrationsQuery.data.twitch.status !== 'CONNECTED' &&
        recommendationsDismiss.twitchGifting.visible,
      isLoading:
        currentShopQuery.isInitialLoading ||
        socialLinksQuery.isInitialLoading ||
        creatorIntegrationsQuery.isInitialLoading,
      suggestion: (
        <Suggestion
          title="Set up Twitch gifting"
          description="Allow viewers to gift products and memberships to chat while you're livestreaming."
          buttonLabel="Set up Twitch gifting"
          buttonTo={routing.apps.twitch}
          imageUrl={setUpTwitchGifting}
          analytics="setUpTwitchGifting"
          onDismiss={createOnDismiss(recommendationsDismiss.twitchGifting.dismiss)}
        />
      ),
    } satisfies Recommendation,
  }
}
